import { toastConstants } from '../constants'

export default function toastReducer(
	state = {
		message: null,
		type: null,
		closing: false
	},
	{ type, message }
) {
	switch (type) {
		case toastConstants.SUCCESS:
		case toastConstants.WARNING:
		case toastConstants.DANGER:
			return Object.assign({}, {
				message,
				type,
				closing: false
			})
		case toastConstants.START_CLOSING:
			return Object.assign({}, state, { closing: true })

		case toastConstants.CLOSE:
			return Object.assign({
				message: null,
				type: null,
				closing: false
			})

		default:
			return state
	}
}
